import { action, observable } from 'mobx';
import { mdiAlertCircleOutline, mdiCheckBold, mdiCloseCircle, mdiInformationOutline } from '@mdi/js';

export interface IErrorNotificationProps {
  type?: string;
  message?: string;
  header?: string;
  infoUrl?: string;
  shortErrorCode?: string;
  fullErrorCode?: string;
  hidden?: boolean;
  timestamp?: string;
  children?: React.ReactNode;
  clear?: any;
}

interface INotification {
  header: string;
  iconPath: string;
  iconColor: string;
}

type NotificationType = 'success' | 'warn' | 'warning' | 'error' | 'default'| 'information';

export class ErrorNotificationVM {
  @observable props: IErrorNotificationProps;
  constructor(props: IErrorNotificationProps) {
    this.props = props;
    this.hidden = this.props.hidden ? this.props.hidden : true;
  }

  notifications: Record<NotificationType, INotification> = {
    success: { header: 'Success!', iconPath: mdiCheckBold, iconColor: 'white' },
    warn: { header: 'Warning!', iconPath: mdiAlertCircleOutline, iconColor: 'rgb(0, 0, 128)' },
    warning: { header: 'Warning!', iconPath: mdiAlertCircleOutline, iconColor: 'rgb(0, 0, 128)' },
    information: { header: 'Alert!', iconPath: mdiInformationOutline, iconColor: '#183f6e' },
    error: { header: 'Error!', iconPath: mdiCloseCircle, iconColor: 'white' },
    default: { header: 'Alert!', iconPath: mdiInformationOutline, iconColor: '#183f6e' },
  };

  @observable hidden: boolean = true;

  @action.bound setHidden(value: boolean) {
    this.hidden = value;
  }

  @action.bound clearNotification() {
    this.setHidden(true);
    if (this.props.clear) {
      this.props.clear();
    }
  }
}
